import { Component, OnInit, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, FormArray, Validators, UntypedFormBuilder } from '@angular/forms';

import { ApiTextMessage } from '../../api-client-module';
import { ProjectLanguage } from '../../firestore-models/project-language';

import { ConfigurationService } from '../../configuration.service';
import { TranslateService } from '@ngx-translate/core';

export interface MultiTextMessageDialogData {
  title?: string;
  text_messages?: ApiTextMessage[];
}

@Component({
  selector: 'app-multi-text-message-dialog',
  templateUrl: './multi-text-message-dialog.component.html',
  styleUrls: ['./multi-text-message-dialog.component.css'],
  standalone: false,
})
export class MultiTextMessageDialogComponent implements OnInit {

  title: string = '';
  // テキスト×言語数
  textMessages: ApiTextMessage[] = [];
  textMessagesFormGroup!: FormGroup;
  textMessagesArrayControl!: FormArray;
  projectLanguages!: Array<ProjectLanguage>;

  currentLang: string = 'ja';
  projectBaseLang: string = 'ja';

  constructor(
    public dialogRef: MatDialogRef<MultiTextMessageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MultiTextMessageDialogData,
    private formBuilder: UntypedFormBuilder,
    private configurationService: ConfigurationService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.projectLanguages = this.configurationService.getProject().languages!;
    this.title = this.data.title!;
    if (!this.title) {
      this.title = this.translate.instant('テキスト設定');
    }
    this.textMessages = this.data.text_messages!;
    if (!this.textMessages) {
      this.textMessages = [];
    }
    this.createForm();
    this.textMessagesArrayControl = this.textMessagesFormGroup.get('textMessages') as FormArray;
    this.currentLang = this.translate.currentLang;
    this.projectBaseLang = this.configurationService.getProject().project_base_lang!;
    //プロジェクト基本言語が管理画面の言語と異なる場合、編集不可にする
    if ((this.currentLang == 'en' && this.projectBaseLang == 'ja') || (this.currentLang == 'ja' && this.projectBaseLang != 'ja')) {
      this.textMessagesFormGroup.disable();
    }
  }

  // テキストフォーム×言語数
  private createForm() {
    let arrayControl = this.formBuilder.array([]);
    let index: number = 0;
    let isAutoAllTrans: boolean = this.textMessages.length ? true : false;
    for (const projectLanguage of this.projectLanguages) {
      let auto_trans = false;
      let text_message = '';
      let trans_text_message = '';
      for (const value of this.textMessages) {
        if (projectLanguage.lang_code === value.lang_code) {
          if (!value.auto_trans && index !== 0) {
            isAutoAllTrans = false;
          }
          auto_trans = value.auto_trans ? value.auto_trans : false;
          text_message = value.text_message;
          trans_text_message = value.trans_text_message;
          break
        }
      }
      arrayControl.push(this.formBuilder.group(
        {
          autoTrans: [auto_trans],
          textMessage: [text_message],
          transTextMessage: [trans_text_message],
        }
      ));
      index++;
    }
    this.textMessagesFormGroup = this.formBuilder.group(
      {
        autoAllTrans: [isAutoAllTrans],
        textMessages: arrayControl
      }
    );
  }

  // 更新ボタン
  addTextMessages(): void {
    if (this.textMessagesFormGroup.valid) {
      let textMessages = [];
      for (const index in this.projectLanguages) {
        const ctrl = this.textMessagesArrayControl.controls[index];
        textMessages.push(
          {
            auto_trans: ctrl.get('autoTrans')!.value,
            lang_code: this.projectLanguages[index].lang_code,
            text_message: ctrl.get('textMessage')!.value,
            trans_text_message: ctrl.get('transTextMessage')!.value,
          }
        )
      }
      this.textMessages = textMessages;
      this.dialogRef.close(this.textMessages);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  // 全言語自動翻訳
  onChangeAutoAllTrans(): void {
    const isAutoAllTrans = this.textMessagesFormGroup.get('autoAllTrans')!.value;
    for (const textMessage of this.textMessagesArrayControl.controls) {
      textMessage.get('autoTrans')!.setValue(isAutoAllTrans);
    }
    this.textMessagesArrayControl.controls[0].get('autoTrans')!.setValue(false);
  }

  // 言語別自動翻訳
  onChangeAutoTrans(): void {
    let isAutoAllTrans: boolean = true;
    let index = 0;
    for (const textMessage of this.textMessagesArrayControl.controls) {
      if (!textMessage.get('autoTrans')!.value && index !== 0) {
        isAutoAllTrans = false;
        break;
      }
      index++
    }
    this.textMessagesFormGroup.get('autoAllTrans')!.setValue(isAutoAllTrans);
  }

}
